import { Modal } from "flowbite-react";

export default function RemoveMember({
  show,
  onClose,
  memberToRemove,
  handleRemoveMember,
  removingMember,
}) {
  return (
    <Modal show={show} size="sm" placement="center" onClose={onClose}>
      {removingMember ? (
        <>
          <p className=" transition-all md:p-12 p-5 text-center text-sm rounded ">
            Removing {memberToRemove?.name}...
          </p>
        </>
      ) : (
        <div className="flex flex-col gap-3 justify-center items-center md:p-12 p-5">
          <h4 className="text-[20px] font-[600] text-[#24211D]">
            Remove Member
          </h4>{" "}
          <p className="text-center text-sm">
            Are you sure you want to remove this member?
          </p>
          <div className="flex gap-3 justify-center items-center mt-2">
            <button
              className="bg-[#ff0000] hover:bg-[#b00404] transition-all px-4 py-2 text-sm rounded text-white"
              onClick={() => handleRemoveMember(memberToRemove)}
            >
              YES
            </button>
            <button onClick={onClose}>Cancel</button>
          </div>
        </div>
      )}
    </Modal>
  );
}
